import Cookies from "js-cookie";

export function getAuthUserToken() {
  const token = localStorage.getItem("authToken");
  const expiry = localStorage.getItem("authTokenExpiry");
  const cookieToken = Cookies.get("authToken");

  // Case 0: cookie itself missing → force logout
  

  // Case 1: no token in localStorage at all
  if (!token) return null;
if (!cookieToken) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authTokenExpiry");
    redirectToSignin();
    return null;
  }
  // Case 2: token found but expiry missing → force logout
  if (!expiry) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authTokenExpiry");
    Cookies.remove("authToken", { domain: getCookieDomain(), path: "/" });
    redirectToSignin();
    return null;
  }

  // Case 3: token + expiry exist but expired → force logout
  if (Date.now() > parseInt(expiry, 10)) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authTokenExpiry");
    Cookies.remove("authToken", { domain: getCookieDomain(), path: "/" });
    redirectToSignin();
    return null;
  }

  // Case 4: both cookie + localStorage token valid
  return token;
}

// Helper: decide cookie domain (dev vs prod)
function getCookieDomain() {
  if (process.env.REACT_APP_ENV_MODE === "development") {
    return "localhost"; // works on localhost
  }
  return process.env.REACT_APP_DOMAIN; // works on production
}

// Small helper for redirect
function redirectToSignin() {
  if (typeof window !== "undefined") {
    window.location.href = process.env.REACT_APP_LOGIN_URL;
  }
}
